import {isnull, localGetBoolean, localSave, Toast} from "./tools";
import AppSDK from "../api/aapp";

export default class PermissionCheck {
  static async checkAudioAndCameraPermission(successCallback, failCallBack, vueObj) {
     await this.checkAudioAndCameraPermissionFromApp(successCallback, failCallBack, vueObj)
     }
  static async checkAudioAndCameraPermissionFromApp(successCallback, failCallBack, vueObj) {
    let hasPermission=await AppSDK.requestLocalPermission();
    if (hasPermission){
      successCallback && successCallback(vueObj)
    }else{
      failCallBack && failCallBack(vueObj)
    }
  }

  static async checkAudioAndCameraPermissionFromWeb(successCallback, failCallBack, vueObj) {
    if (localGetBoolean(global.CHECK_WEB_AC_PERMISSION, false)) {
      successCallback && successCallback(vueObj)
      return
    }
    try {
      let devices = await AgoraRTC.getDevices()
      console.log('permisssionCheck:' + JSON.stringify(devices))
      let audioDevices = devices.filter(function (device) {
        return device.kind === 'audioinput' && !isnull(device.deviceId)
      })
      if (isnull(audioDevices)) {
        let microAudioDevice = await AgoraRTC.getMicrophones()
        console.log('permisssionCheck-micro:' + JSON.stringify(microAudioDevice))
        audioDevices = microAudioDevice.filter(function (device) {
          return !isnull(device.deviceId)
        })
      }
      let videoDevices = devices.filter(function (device) {
        return device.kind === 'videoinput' && !isnull(device.deviceId)
      })
      if (isnull(videoDevices)) {
        let cameraVideoDevice = await AgoraRTC.getCameras()
        console.log('permisssionCheck-camera:' + JSON.stringify(cameraVideoDevice))
        videoDevices = cameraVideoDevice.filter(function (device) {
          return !isnull(device.deviceId)
        })
      }
      if (!isnull(videoDevices) && !isnull(audioDevices)) {
        let audioTrack = await AgoraRTC.createMicrophoneAudioTrack({microphoneId: audioDevices[0].deviceId})
        let videoTrack = await AgoraRTC.createCameraVideoTrack({cameraId: videoDevices[0].deviceId})
        if (!isnull(audioTrack) && !isnull(videoTrack)) {
          audioTrack.stop()
          audioTrack = null
          videoTrack.stop()
          videoTrack = null
          localSave(global.CHECK_WEB_AC_PERMISSION, true)
          StatisticsUtils.Permission.trackGrantPermission()
          new Promise(resolve => {
            successCallback && successCallback(vueObj)
          });
          return
        }

      }
      new Promise(resolve => {
        failCallBack && failCallBack(vueObj)
      });
    } catch (e) {
      console.table(e)
      console.log("permission check:" + e.code)
      failCallBack && failCallBack(vueObj)
    }


//     if (!localGetBoolean(global.CHECK_WEB_AC_PERMISSION, false)) {
//       // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
//       if (navigator.mediaDevices === undefined) {
//         navigator.mediaDevices = {};
//       }
//
// // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
// // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
//       if (navigator.mediaDevices.getUserMedia === undefined) {
//         navigator.mediaDevices.getUserMedia = function (constraints) {
//
//           // 首先，如果有getUserMedia的话，就获得它
//           var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
//
//           // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
//           if (!getUserMedia) {
//             return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
//           }
//
//           // 否则，为老的navigator.getUserMedia方法包裹一个Promise
//           return new Promise(function (resolve, reject) {
//             getUserMedia.call(navigator, constraints, resolve, reject);
//           });
//         }
//       }
//       navigator.mediaDevices.getUserMedia({video: true, audio: true}).then(function (mediaStream) {
//         if (!isnull(mediaStream))
//           mediaStream.getTracks()&&mediaStream.getTracks().forEach((track)=>{
//             Toast.error('track-'+track.id+'['+track.kind+']:'+track.readyState,vueObj)
//             track&&track.stop()
//           })
//         localSave(global.CHECK_WEB_AC_PERMISSION, true)
//         successCallback && successCallback(vueObj)
//       }).catch(error => {
//         // Toast.error(error.name,target)
//         // if (error.name == 'NotAllowedError') {
//         //   Toast.error('Turn on camera access to start private call', target)
//         // } else {
//         //   target.execRequest()
//         // }
//         failCallBack && failCallBack(vueObj)
//       })
//     } else
//       successCallback && successCallback(vueObj)
  }
}



// WEBPACK FOOTER //
// ./src/utils/PermissionUtils.js